import { jsx as _jsx } from "react/jsx-runtime";
import styles from './FlowContainer.module.scss';
export const FlowContainer = ({ children }) => {
    return _jsx("div", { className: styles.container, children: children });
};
